import UserManagementForm from "@/components/Forms/UserManagementForm";

const UserManagementCreate = () => {
  return <UserManagementForm create={true} />;
};

export default UserManagementCreate;
